import styled from 'styled-components';

import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

export const SpeedTestContainer = styled.div`
    position: relative;
    height: 650px;
`;

type VisibleProps = {
    $isVisible: boolean;
};

export const SpeedTestIframeLoader = styled.div<VisibleProps>`
    background: ${getPurpurColor('transparentWhite800')};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    display: ${(props) => (props.$isVisible ? 'flex' : 'none')};
`;

export const SpeedTestIframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: 0;
`;
